import { ChangedEvent, Diagram } from 'gojs';
import { Observable, Observer } from 'rxjs';

export const fromModelChanged = (diagram: Diagram): Observable<ChangedEvent> =>
  new Observable((observer: Observer<ChangedEvent>) => {
    const listener = observer.next.bind(observer);
    diagram.addModelChangedListener(listener);
    return () => {
      diagram.removeModelChangedListener(listener);
    };
  });
